function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import OidcProvider from "./OidcProvider";
import createUserManager from "./createUserManager";
import { initConfig } from "./config";
import { Log } from "oidc-client";
var userManager;
var config;

var getUserManager = function getUserManager() {
  return userManager;
};

console.log(Log.level);

var configure = function configure() {
  var configOverrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var appName = configOverrides.appName;

  if (!appName) {
    throw new Error("'appName' must be provided to Auth.Configure({ appName: 'example' })");
  }

  var c = initConfig(appName);
  userManager = createUserManager(_objectSpread({}, c, {}, configOverrides));
  config = _objectSpread({}, c, {}, configOverrides);

  if (config.logger) {
    Log.logger = config.logger;
  }

  if (config.level) {
    Log.level = config.level;
  }
};

var signOut = function signOut() {
  return getUserManager().signoutRedirect();
};

export var AuthenticationProvider = function AuthenticationProvider(_ref) {
  var children = _ref.children,
      onSignin = _ref.onSignin,
      onError = _ref.onError,
      history = _ref.history;
  return React.createElement(OidcProvider, {
    userManager: getUserManager(),
    config: config,
    onSignin: onSignin,
    onError: onError,
    history: history
  }, children);
};
export default {
  configure: configure,
  signOut: signOut,
  _getUserManager: getUserManager
};